class ElementInViewPortDetector {
    constructor(elementId) {
        this.el = document.getElementById(elementId);
        this.init();
    }

    init() {
        this.addScrollEventListeners();
    }

    isElementInViewport() {
        const rect = this.el.getBoundingClientRect();
        const vpTop = window.innerHeight || document.documentElement.clientHeight;
        const vpBottom = 0;

        return (
            rect.bottom > vpBottom &&
            rect.top < vpTop
        );
    }

    animateOnceInViewPort() {
        if (this.isElementInViewport() && this.el.getAttribute("data-in-viewport") === "false") {
            console.log("Detected");
            this.el.setAttribute("data-in-viewport", "true");
        }
    }

    addScrollEventListeners() {
        window.addEventListener('scroll', () => this.animateOnceInViewPort());
        document.body.addEventListener('touchmove', () => this.animateOnceInViewPort());
    }
}